import { getUser } from '../user/user-actions';
import { getMarketingMaterials } from '../marketing-materials/actions';
import { hydrateFromServer as getSettings } from '../../stores/settings/settings-actions';

import {
  DASHBOARD_INITIALIZE_SUCCESS,
  DASHBOARD_SHOW_ONBOARDING_DIALOG,
  DASHBOARD_CLOSE_ONBOARDING_DIALOG,
} from './constants';

export const appInitSuccess = () => (
  {
    type: DASHBOARD_INITIALIZE_SUCCESS,
  }
);

export const showOnboardingDialog = () => (
  {
    type: DASHBOARD_SHOW_ONBOARDING_DIALOG,
  }
);

export const closeOnboardingDialog = () => (
  {
    type: DASHBOARD_CLOSE_ONBOARDING_DIALOG,
  }
);

export const initDashboard = () => (dispatch) => {
  return dispatch(getUser()).then(res => {
    [getMarketingMaterials.bind(this, res.user.user.userID),
      getSettings,
    ].forEach(fn => dispatch(fn()));
  }).then(() => dispatch(appInitSuccess()));
};



// WEBPACK FOOTER //
// ./src/app/stores/dashboard/actions.js